import * as LabelPrimitive from '@radix-ui/react-label'
import { styled } from 'style'

import Box from 'components/atomic/atoms/box'
import AtomInput, {
  InputCopy as AtomInputCopy,
  InputSearch as AtomInputSearch,
  InputUrl as AtomInputUrl,
} from 'components/atomic/atoms/input'
import AtomTextArea from 'components/atomic/atoms/textarea'

export const Root = styled(Box, {
  spaceY: 2,
  variants: {
    row: {
      true: {
        spaceY: 0,
        spaceX: 2,
      },
    },
  },
})

export const LabelGroup = styled(Box, {
  spaceY: 2,
  variants: {
    row: {
      true: {
        spaceY: 0,
        spaceX: 2,
      },
    },
  },
})

export const Label = styled(LabelPrimitive.Root, {
  color: '$text1',
  fontWeight: '$semi-bold',
  fontSize: '$sm',
  lineHeight: '$sm',
})

export const HelpText = styled('p', {
  fontSize: '$xs',
  color: '$text2',

  '&::first-letter': {
    textTransform: 'uppercase',
  },

  variants: {
    error: {
      true: {
        color: '$textError',
      },
    },
  },
})

export const Input = AtomInput
export const InputUrl = AtomInputUrl
export const InputSearch = AtomInputSearch
export const InputCopy = AtomInputCopy
export const TextArea = AtomTextArea
